module.exports = __webpack_public_path__ + "img/icn-epargne.3eb8e389.svg";